module.exports = require('./helpers/bundle-url').getBundleURL('ivvNX') + "logo.7718c6df.svg";